export function parseName(name) {
    const name_array = name.split(' ');
    return name_array.map(val => (val.charAt(0).toUpperCase())).join("");
}